import { createAction } from 'redux-act';

/** Полезная нагрузка формы комиссии по сделке (данные с бэка или для создания). */
export type TradeCommissionFormPayload = Record<string, unknown> | null;

export const setTradeCommissionModalVisible = createAction<boolean>(
  'SET_TRADE_COMMISSION_MODAL_VISIBLE'
);
export const setTradeCommissionForm = createAction<TradeCommissionFormPayload>(
  'SET_TRADE_COMMISSION_FORM'
);
export const setTradeId = createAction<number | null>('SET_TRADE_COMMISSION_TRADE_ID');
